/** SWR cache keys shared across session list views and mutations */
export function bookedSessionsListKey(): string {
  return `${process.env.REACT_APP_API_URL}/session/bookedSession/`;
}
